export default __webpack_public_path__ + "static/appstore-6020e9179c8c1eb381ce37665882546c.png";